<template>
  <div v-if="!item.saved">
    <div class="text-black flex justify-between content-center dark:text-white">
      <div class="cursor-pointer" @click="handleClick">
        {{ humanizeFilter(item?.filter) }}
      </div>
      <div v-if="!isSaved" class="cursor-pointer" @click="iconClick">
        <Save class="translate-y-2 translate-x-[-3px]" />
      </div>
      <div v-else class="cursor-pointer" @click="iconClick">
        <Heart fill="black" class="translate-y-2" />
      </div>
    </div>

    <div class="text-[#899399]">
      {{
        Math.floor((new Date() - new Date(item.date)) / 86400000)
          ? Math.floor((new Date() - new Date(item.date)) / 86400000) === 1
            ? $t("yesterday")
            : `${Math.floor((new Date() - new Date(item.date)) / 86400000)} ` + $t("days ago")
          : $t("today")
      }}
    </div>
    <div class="bg-[#B3CAD6] dark:bg-dark-divider-border my-[8px] h-px" />
  </div>
  <div v-else class="cursor-pointer">
    <div class="text-black flex justify-between content-center">
      <div class="dark:text-white" @click="handleClick">
        {{ humanizeFilter(item?.filter) }}
      </div>
      <Trash2 class="cursor-pointer translate-y-4 h-4" @click="iconClick" />
    </div>
    <div class="text-[#899399]">
      {{
        Math.floor((new Date() - new Date(item.date)) / 86400000)
          ? Math.floor((new Date() - new Date(item.date)) / 86400000) === 1
            ? $t("yesterday")
            : `${Math.floor((new Date() - new Date(item.date)) / 86400000)} ` + $t("days ago")
          : $t("today")
      }}
    </div>
    <div class="bg-[#B3CAD6] dark:bg-dark-divider-border my-[8px] h-px" />
  </div>
</template>

<script>
import { Save, Trash2, Heart } from "lucide-vue-next"

export default {
  components: {
    Heart,
    Save,
    Trash2
  },

  props: {
    item: {
      type: Object,
      required: true
    },
    searchItemClick: {
      type: Function,
      required: true
    },
    saveOrDeleteItemClick: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      isSaved: false
    }
  },
  methods: {
    iconClick() {
      // this.isSaved = true
      this.saveOrDeleteItemClick(this.item)
    },
    handleClick() {
      this.searchItemClick(this.item)
    },
    humanizeFilter(filter) {
      if (filter) {
        let string = ""

        filter?.split(" ").forEach((f) => {
          if (this.$utils.getMetricByReferenceName(f.toString())) {
            string = string + " " + this.$utils.getMetricByReferenceName(f).name
          } else if (f === ">") {
            string = string + " " + this.$t("greater than")
          } else if (f === "<") {
            string = string + " " + this.$t("less than")
          } else if (f.toString().includes("AND")) {
            string = string + " " + this.$t("AND")
          } else if (f.toString().includes("OR")) {
            string = string + " " + this.$t("OR")
          } else {
            string = string + " " + f.toString()
          }
        })

        let clean_string = ""

        string.split("").forEach((s) => {
          if (s !== "(" && s !== ")") {
            clean_string = clean_string + s
          }
        })

        return clean_string
      }
    }
  }
}
</script>
